;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.OffSeasonBase = View.OffSeasonBase.extend({
		club_name: 'Essendon',
		winner: 'Scott Miller',
		hide_winners: true,
	});

}(window, APP, Backbone, Marionette, $, _));